<script setup>
import { TabsContent, TabsIndicator, TabsList, TabsRoot, TabsTrigger } from 'reka-ui'

const user = useState("auth");


</script>

<template>
  <div>
    <TabsRoot class="" default-value="tab1" dir="rtl">
      <TabsList class="flex items-center shrink-0 relative border-b-2 border-b-strong">
        <TabsIndicator class="TabsIndicator">
          <div class="bg-brand size-full"/>
        </TabsIndicator>
        <TabsTrigger class="text-caption h-12 flex-1 data-[state=active]:text-brand-darker outline-none cursor-pointer" value="tab1">حساب کاربری</TabsTrigger>
        <TabsTrigger class="text-caption h-12 flex-1 data-[state=active]:text-brand-darker outline-none cursor-pointer" value="tab2">رمز عبور</TabsTrigger>
      </TabsList>
      <TabsContent class="mt-8 grow outline-none" value="tab1">
        <ProfileAcountTab :user="user" />
      </TabsContent>
      <TabsContent class="mt-8 grow outline-none" value="tab2">
        <ProfilePasswordTab />
      </TabsContent>
    </TabsRoot>
  </div>
</template>

<style scoped>
.TabsIndicator {
  position: absolute;
  left: 0;
  height: 2px;
  bottom: -2px;
  width: var(--reka-tabs-indicator-size);
  transform: translateX(var(--reka-tabs-indicator-position));
  border-radius: 9999px;
  transition-property: width, transform;
  transition-duration: 200ms;
}
</style>